//let prod = "https://com-sparkle-sparkle.herokuapp.com/api";
//let dev = "https://com-sparkle-stage.herokuapp.com/api";
//let local = "http://localhost:8001/api"

let API = `${process.env.GATSBY_API_URL}/api`;
let SOCKET_URL = `${process.env.GATSBY_API_URL}`;

export { API, SOCKET_URL };
